import getDataFromDocument from "./getDataFromDocument";

const getDataFromDocuments = docs => docs.map(getDataFromDocument);

export default getDataFromDocuments;
